import React from "react";
import {useRef, useState} from "react";
import usePageCache from "../../hooks/usePageCache.jsx";
import {useApi} from "../../hooks/useApi.jsx";
import {AppPath} from "../../Router/AppRouter.jsx";
import {SearchBox} from "../../components/base/input/SearchBox.jsx";
import {PageLayout} from "../../components/layout/Page/PageLayout.jsx";
import {PagedListView} from "../../components/composite/PagedListView/PagedListView.jsx";
import {Card} from "../../components/composite/Card/Card.jsx";
import {DataLabel} from "../../components/base/typography/DataLabel.jsx";
import {InlineText} from "../../components/base/typography/InlineText.jsx";
import {DateFormatter} from "../../utils/DateFormatter.js";
import {HighlightedText} from "../../components/base/typography/HighlightedText.jsx";
import {GridContainerFlex} from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

export const ShipmentHistory = () => {
    const {api, callApi} = useApi();
    const pagedListViewRef = useRef();
    const [activeSearchTerm, setActiveSearchTerm] = usePageCache(`${AppPath.shipmentHistory}.searchTerm`, '');
    const [dataPage, setDataPage] = useState();

    const handleSearch = async (value) => {
        await setActiveSearchTerm(value);
        await pagedListViewRef.current.reload();
    }

    const loadShipmentHistoryPage = async (pageInfo) => {
        await callApi({
            request: async () => {
                setDataPage(await api.getShipmentHistory(pageInfo.pageIndex, pageInfo.pageSize, activeSearchTerm, null));
            }
        });
    };

    const ShipmentHistoryItemRender = (props) => {
        const { dataItem } = props;
        return (
                <Card style={{margin: "8px"}}>
                  <GridContainerFlex justifyContent={"start"}>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Type: </DataLabel>
                          {dataItem.freightCategory}
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>BOL: </DataLabel>
                          <HighlightedText text={dataItem.bolNumber} highlight={activeSearchTerm} />
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Is Blind: </DataLabel>
                          <InlineText>{dataItem.isBlind ? "YES" : "NO"}</InlineText>
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Is HazMat: </DataLabel>
                          <InlineText>{dataItem.isHazmat ? "YES" : "NO"}</InlineText>
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>BOL Date: </DataLabel>
                          <InlineText>{DateFormatter.short(dataItem.bolDate)}</InlineText>
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Shipment Status: </DataLabel>
                          <InlineText>{dataItem.shipmentStatus}</InlineText>
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Remaining Balance: </DataLabel>
                          <InlineText>{dataItem.remainingBalance}</InlineText>
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Equipment Type: </DataLabel>
                          <HighlightedText text={dataItem.equipmentType} highlight={activeSearchTerm} />
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Origin: </DataLabel>
                          <HighlightedText text={`${dataItem.originCity}, ${dataItem.originState}`} highlight={activeSearchTerm} />
                      </GridItemFlex>
                      <GridItemFlex xs={12} sm={6} md={6} lg={3}>
                          <DataLabel>Destination: </DataLabel>
                          <HighlightedText text={`${dataItem.destinationCity}, ${dataItem.destinationState}`} highlight={activeSearchTerm} />
                      </GridItemFlex>
                  </GridContainerFlex>
                </Card>
        )
    }

    return (
        <PageLayout>
            <GridContainerFlex>
                <GridItemFlex xs={12}>
                    <GridContainerFlex justifyContent={"start"}>
                        <GridItemFlex>
                            <SearchBox activeSearchValue={activeSearchTerm} onSearch={handleSearch} placeholder={"Search..."}/>
                        </GridItemFlex>
                    </GridContainerFlex>
                </GridItemFlex>
                <GridItemFlex xs={12}>
                    <PagedListView
                        data={dataPage}
                        itemRender={ShipmentHistoryItemRender}
                        onPageInfoChange={loadShipmentHistoryPage}
                        ref={pagedListViewRef}
                    />
                </GridItemFlex>
            </GridContainerFlex>
        </PageLayout>
    );
};